import { initObservability } from "./observability";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "@/styles-css/shadcn.css";
import "@/styles-css/preview.css";
import { App } from "@/app";

// Initialize observability (OTel traces + OpenObserve RUM/Logs)
initObservability();

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root container '#root' not found in document");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>
);
